export const currency = [
  { label: "$   - Australian Dollar", code: "AUD", symbol: "$" },
  { label: "£   - British Pound Sterling", code: "GBP", symbol: "£" },
  { label: "$   - Canadian Dollar", code: "CAD", symbol: "$" },
  { label: "¥   - Chinese Yuan", code: "CNY", symbol: "¥" },
  { label: "Kč  - Czech Republic Koruna", code: "CZK", symbol: "Kč" },
  { label: "Kr. - Danish Krone", code: "DKK", symbol: "Kr." },
  { label: "ج.م - Egyptian Pound", code: "EGP", symbol: "ج.م" },
  { label: "€   - Euro", code: "EUR", symbol: "€" },
  { label: "$   - Hong Kong Dollar", code: "HKD", symbol: "$" },
  { label: "₹   - Indian Rupee", code: "INR", symbol: "₹" },
  { label: "Rp  - Indonesian Rupiah", code: "IDR", symbol: "Rp" },
  { label: "﷼   - Iranian Rial", code: "IRR", symbol: "﷼" },
  { label: "د.ع - Iraqi Dinar", code: "IQD", symbol: "د.ع" },
  { label: "₪   - Israeli New Sheqel", code: "ILS", symbol: "₪" },
  { label: "L,£ - Italian Lira", code: "ITL", symbol: "L,£" },
  { label: "¥   - Japanese Yen", code: "JPY", symbol: "¥" },
  { label: "ك.د - Kuwaiti Dinar", code: "KWD", symbol: "ك.د" },
  { label: "RM  - Malaysian Ringgit", code: "MYR", symbol: "RM" },
  { label: "Rf  - Maldivian Rufiyaa", code: "MVR", symbol: "Rf" },
  { label: "MRU - Mauritanian Ouguiya", code: "MRO", symbol: "MRU" },
  { label: "₨   - Mauritian Rupee", code: "MUR", symbol: "₨" },
  { label: "ƒ   - Netherlands Antillean Guilder", code: "ANG", symbol: "ƒ" },
  { label: "$   - New Taiwan Dollar", code: "TWD", symbol: "$" },
  { label: "$   - New Zealand Dollar", code: "NZD", symbol: "$" },
  { label: "₩   - North Korean Won", code: "KPW", symbol: "₩" },
  { label: "kr  - Norwegian Krone", code: "NOK", symbol: "kr" },
  { label: ".ع.ر - Omani Rial", code: "OMR", symbol: ".ع.ر" },
  { label: "₨   - Pakistani Rupee", code: "PKR", symbol: "₨" },
  { label: "₱   - Philippine Peso", code: "PHP", symbol: "₱" },
  { label: "zł  - Polish Zloty", code: "PLN", symbol: "zł" },
  { label: "ق.ر - Qatari Rial", code: "QAR", symbol: "ق.ر" },
  { label: "lei - Romanian Leu", code: "RON", symbol: "lei" },
  { label: "₽   - Russian Ruble", code: "RUB", symbol: "₽" },
  { label: "﷼   - Saudi Riyal", code: "SAR", symbol: "﷼" },
  { label: "$   - Singapore Dollar", code: "SGD", symbol: "$" },
  { label: "R   - South African Rand", code: "ZAR", symbol: "R" },
  { label: "₩   - South Korean Won", code: "KRW", symbol: "₩" },
  { label: "Rs  - Sri Lankan Rupee", code: "LKR", symbol: "Rs" },
  { label: "kr  - Swedish Krona", code: "SEK", symbol: "kr" },
  { label: "CHf - Swiss Franc", code: "CHF", symbol: "CHf" },
  { label: "LS  - Syrian Pound", code: "SYP", symbol: "LS" },
  { label: "฿   - Thai Baht", code: "THB", symbol: "฿" },
  { label: "₺   - Turkish Lira", code: "TRY", symbol: "₺" },
  { label: "إ.د - United Arab Emirates Dirham", code: "AED", symbol: "إ.د" },
  { label: "$   - US Dollar", code: "USD", symbol: "$" },
];
